import { useCallback, useState } from 'react';
import { useDebouncedEffect } from '../../../Helpers/CustomHooks';

export const useCustomerFiltering = (query, initialCustomers, setFilteredCustomers) => {
  const [list, setList] = useState(initialCustomers);

  const findCustomers = useCallback(() => {
    if (query?.length === 0) {
      setList(initialCustomers);
      setFilteredCustomers([]);
      return;
    }

    const filteredList = [];
    var searchFunction = getSearchFunctionBasedOnQuery(query, filteredList);

    for (const customer of initialCustomers) {
      searchFunction(customer);
    }

    setFilteredCustomers(filteredList);
    setList(filteredList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useDebouncedEffect(findCustomers, 500);

  return list;
};

/**
 * Determines if user wanted to search by customer number, legal number or name
 * @returns a function
 */
const getSearchFunctionBasedOnQuery = (query, list) => {
  if (query.match(/^\d+(-\d*)?$/i)) {
    // if format 123456789 or 12345-1234, then search by legal number
    return customer => {
      if (customer.legalNumber.includes(query.replaceAll('-', ''))) {
        list.push(customer);
      }
    };
  } else if (query.match(/^WP\d*$/i)) {
    // if format is WP0000123, then search by customer number, ignoring 0-es after "WP"
    var clipZeroesRegex = /^WP0*/i;
    return customer => {
      if (customer.customerNumber.replace(clipZeroesRegex, 'WP').includes(query.replace(clipZeroesRegex, 'WP'))) {
        list.push(customer);
      }
    };
  } else {
    return customer => {
      if (customer.customerName.toLowerCase().includes(query.toLowerCase())) {
        list.push(customer);
      }
    };
  }
};
